import io from "socket.io-client"
import { socketEvents } from "./Event";
import { socketUrl } from "../Services/api-services";
export const socket = io(socketUrl);

export const initSockets = ({ setValue }) => {
  socketEvents({ setValue });
  // setValue    ^ is passed on to be used by socketEvents
};